import React, { useReducer, useMemo, createContext } from "react";
import { init_local, local_reducer } from "./localReducer";

export const LocalStoreContext = createContext(undefined);

export const LocalStoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(local_reducer, init_local);
  const store = useMemo(() => [state, dispatch], [state]);
  return (
    <LocalStoreContext.Provider value={store}>
      {children}
    </LocalStoreContext.Provider>
  );
};
